// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__k1TpD","label":"Completed_label__xDlT1"};